/**
 * Store detection radius presets (PLAN §4.7): a normal store is caught within
 * 150 m of its pin, a big-box store within 300 m. Anything else is a custom
 * radius, bounded by `createStoreRequestSchema` (25–2000 m).
 */
export const STORE_RADIUS_MIN_M = 25;
export const STORE_RADIUS_MAX_M = 2000;
export const STORE_RADIUS_PRESETS = {
    normal: 150,
    bigBox: 300,
};
export const STORE_RADIUS_PRESET_LABEL = {
    normal: 'Normal (150 m)',
    bigBox: 'Big-box (300 m)',
    custom: 'Custom',
};
/** Which preset a stored radius corresponds to; anything off-preset is "custom". */
export function radiusPresetFor(radiusM) {
    if (radiusM === STORE_RADIUS_PRESETS.normal)
        return 'normal';
    if (radiusM === STORE_RADIUS_PRESETS.bigBox)
        return 'bigBox';
    return 'custom';
}
/**
 * Parses a custom radius typed by a person ("220", " 450 "). Whole metres
 * within the API's bounds, otherwise null.
 */
export function parseCustomRadius(input) {
    const trimmed = input.trim();
    if (!/^\d+$/.test(trimmed))
        return null;
    const n = Number(trimmed);
    return n >= STORE_RADIUS_MIN_M && n <= STORE_RADIUS_MAX_M ? n : null;
}
/** The radius to send for a preset; for "custom" the parsed input, or null when invalid. */
export function radiusForPreset(preset, customInput = '') {
    if (preset === 'custom')
        return parseCustomRadius(customInput);
    return STORE_RADIUS_PRESETS[preset];
}
//# sourceMappingURL=storeRadius.js.map